import React, { Component } from 'react'; //different
import SweetAlert from 'react-bootstrap-sweetalert';
//import Paoyingchub from './game/paoyingchub';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import { isMobile } from 'react-device-detect';
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import md5 from 'md5';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";

const GameSkeleton = () => (
    <div className="w-full">
        {/* การ์ด */}
        <div className="relative pb-[142%] rounded-[14px] overflow-hidden bg-[#1a1a1a]">
            <svg
                viewBox="0 0 100 142"
                preserveAspectRatio="none"
                className="absolute inset-0 w-full h-full"
            >
                <defs>
                    <linearGradient id="g">
                        <stop offset="20%" stopColor="#2a2a2a">
                            <animate
                                attributeName="offset"
                                values="-2; 1"
                                dur="1.4s"
                                repeatCount="indefinite"
                            />
                        </stop>
                        <stop offset="50%" stopColor="#3a3a3a">
                            <animate
                                attributeName="offset"
                                values="-1.5; 1.5"
                                dur="1.4s"
                                repeatCount="indefinite"
                            />
                        </stop>
                        <stop offset="80%" stopColor="#2a2a2a">
                            <animate
                                attributeName="offset"
                                values="-1; 2"
                                dur="1.4s"
                                repeatCount="indefinite"
                            />
                        </stop>
                    </linearGradient>
                </defs>

                <rect x="0" y="0" width="100" height="142" fill="url(#g)" />
            </svg>
        </div>

        {/* ชื่อเกม */}
        <div className="mt-1 h-[10px] w-[80%] mx-auto rounded bg-[#2a2a2a] animate-pulse" />
    </div>
);

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listitallgame: this.props.listitallgame,
            username: this.props.username,
            providorlist: this.props.providorlist,
            activeCard: null,
            segslist: { seg1: "", seg2: "", partner: "" },
            playerUsername: this.props.userid,
            activeProvider: {
                icon: "https://cdn.zabbet.com/providers/icon/misolt.png",
                partnerdesc: null,
                partner: null,
            },
            balance: this.props.balance,
            loginstate: this.props.loginstate,
        }
        console.log("componentDidUpdatex", this.props)
        // this.handleClick = this.handleClick.bind(this);
        // this.handlePageChange = this.handlePageChange.bind(this);
        // this.hideAlert = this.hideAlert.bind(this);

    }
    componentDidUpdate(prevProps, prevState) {
        const { point, userid } = this.props; // destructuring for easier access


        // Check if username has changed
        if (prevProps.playerUsername !== userid) {
            if (userid !== this.state.playerUsername) {
                console.log("componentDidUpdatex - username updated:", userid);
                this.setState({ playerUsername: userid });
            }
        }
    }

    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    componentDidMount() {
        this.checklogingame();
        const pathname = window.location.pathname
            .replace(/^\/+|\/+$/g, "")
            .split("/");

        const seg1 = pathname[0] || "";
        const seg2 = pathname[1] || "";
        const seg3 = pathname[2] || ""; // 👈 partner จาก url

        this.setState({
            segslist: { seg1, seg2 },
        });

        // ถ้ามี provider list แล้ว
        if (this.props.providorlist?.length) {
            const matched =
                this.props.providorlist.find(p => p.partner === seg3)
                || this.props.providorlist[0]; // fallback ตัวแรก

            this.setState({
                activeProvider: {
                    partner: matched.partner,
                    partnerdesc: matched.description,
                    icon: matched.imagesec,
                },
            });
        }
    }

    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    redeem = async (e, gameIdx, partner) => {
        e?.preventDefault();
        var userAgent = navigator.userAgent
        console.log("🎮 [REDEEM] start", { gameIdx, partner });
        const { ok, Username } = await this.checklogingame();
        console.log("🎮 [REDEEM] checklogingame", { ok, Username });
        if (!ok) {
            return this.notify("error", "คุณยังไม่ได้เข้าสู่ระบบ");
        }
        let payload = {
            gameId: gameIdx,
            partner: partner,
            playerUsername: this.state.username,
            isMobile: isMobile,
            System: Systems,
            demo: false
        }
        console.log("🎮 [REDEEM] payload", payload);
        instance.post("/api/v1/tablauncher", payload).then((res) => {

            if (res.data.status === 200) {
                console.log(res.data.message);
                var test = res.data.message.launcher
                if (test !== undefined) {
                    if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                        window.location.href = test.mobile;
                    }
                    else {
                        if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                        else window.open(test.mobile);
                    }
                }
                else if (test === undefined) {
                    return this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");

                }
            }
            else if (test === undefined) {
                return this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");

            }
        });



    }

    checklogingame = async () => {
        const token = localStorage.getItem('auth_token');

        if (!token) {
            this.setState({ loginstate: false });
            await this.notify("warning", "Session ของท่านหมดอายุ กรุณา login");
            return { ok: false };
        }

        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;

            const ok = await this.rechecklogingame(Username, token);

            return {
                ok,
                Username
            };

        } catch (err) {
            localStorage.clear();
            this.setState({ loginstate: false });
            return { ok: false };
        }
    };
    rechecklogingame = async (Username, token) => {
        console.log("rechecklogingame")
        try {
            const res = await instance.post(
                "/api/v1/checkpoint",
                {
                    userid: Username,
                    System: Systems,
                    authen: true,
                    Function: "rechecklogin-navbar.js"
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (res.data.status === 200) {
                this.setState({
                    loginstate: true,
                    username: Username
                });
                return true;
            }

            if (res.data.status === 401) {
                localStorage.clear();
                this.setState({ loginstate: false });
                return false;
            }

            return false;

        } catch (err) {
            localStorage.clear();
            this.setState({ loginstate: false });
            return false;
        }
    }
    addDefaultSrc(ev, listitem) {
        const origin = listitem.split("http");
        if (origin.length > 1) {
            const origin = listitem.split("https");
            if (origin.length > 1) return listitem;
            else return listitem.replace("http", "https");
        }
        else {
            return "https://ardmhzelxcmj.ocrazeckyunc.com" + listitem

        }

    }
    async checklogin() {
        const token = localStorage.getItem('auth_token');

        console.log(token)
        if (!token) {
            this.setState({ loginstate: false });
            await this.notify("warning", "Session ของท่านหมดอายุ กรุณา login");
            return { ok: false };
        }

        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;

            const ok = await this.rechecklogin(Username, token);
            return { ok, Username };

        } catch (err) {
            localStorage.clear();
            this.setState({ loginstate: false });
            return { ok: false };
        }
    }


    async rechecklogin(Username, token) {
        try {
            const res = await instance.post(
                "/api/v1/checkpoint",
                {
                    userid: Username,
                    System: Systems,
                    authen: true,
                    Function: "rechecklogin-navbar.js"
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (res.data.status === 200) {
                this.setState({
                    loginstate: true,
                    username: Username
                });
                return true;
            }

            if (res.data.status === 401) {
                localStorage.clear();
                this.setState({ loginstate: false });
                return false;
            }

            return false;

        } catch (err) {
            localStorage.clear();
            this.setState({ loginstate: false });
            return false;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        console.log("componentDidUpdate", this.props)
        const { userid, listitallgame, balance, providorlist, loginstate } = this.props; // destructuring for easier access

        console.log("componentDidUpdate - userid updated:", userid, prevProps.userid);
        // Check if point has changed
        if (prevProps.userid !== userid) {
            if (userid !== this.state.username) {
                console.log("componentDidUpdate - userid updated:", userid);
                this.setState({ username: userid });
            }
        }
        if (prevProps.loginstate !== loginstate) {
            if (loginstate !== this.state.loginstate) {
                console.log("componentDidUpdate - loginstate updated:", loginstate);
                this.setState({ loginstate });
            }
        }
        if (prevProps.listitallgame !== listitallgame) {
            if (listitallgame !== this.state.listitallgame) {
                console.log("componentDidUpdate - listitallgame updated:", listitallgame);
                this.setState({ listitallgame });
            }
        }
        if (prevProps.providorlist !== providorlist) {
            if (providorlist !== this.state.providorlist) {
                console.log("componentDidUpdate - providorlist updated:", providorlist);
                this.setState({ providorlist });
            }
        }
        if (prevState.providorlist !== this.state.providorlist) {
            this.providerSwiper?.update();
        }

        if (prevProps.balance !== balance) {
            if (balance !== this.state.balance) {
                console.log("componentDidUpdate - balance updated:", balance);
                this.setState({ balance });
            }
        }



    }


    addDefaultSrc(ev, listitem) {
        const origin = listitem.split("http");
        if (origin.length > 1) {
            const origin = listitem.split("https");
            if (origin.length > 1) return listitem;
            else return listitem.replace("http", "https");
        }
        else {
            return "https://ardmhzelxcmj.ocrazeckyunc.com" + listitem

        }

    }

    render() {
        console.log("componentDidUpdate ", this.state.providorlist)

        const { listitallgame, providorlist, segslist } = this.state
        return (
            <>
                <main className="no-scrollbar z-40 flex flex-1 flex-col justify-start overflow-y-auto">
                    <div className="relative flex flex-col w-full h-full overflow-hidden pt-2 select-none">
                        <div
                            className="absolute right-0 w-10 h-10 bg-[#161616] rounded ml-auto mr-4 mb-3 -mt-2 flex justify-center items-center cursor-pointer z-50 transition-all opacity-0 bottom-0"
                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                        >
                            <img src="/build/web/igame-index-lobby-wm/img/to_top.png" width={17} height={9} alt="to_top" />
                        </div>
                        <div className="relative w-full h-[48px] flex items-center px-2 py-3 md:px-14">
                            <div>
                                <button className="flex items-center" type="button" onClick={() => {

                                    this.props.onNavigate(
                                        `/mainlobby`
                                    );
                                }}
                                >
                                    <div className=" relative w-[32px] h-[32px] md:w-[36px] md:h-[36px] ">
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "absolute",
                                                inset: 0
                                            }}
                                        >
                                            <img
                                                src="/build/web/igame-index-lobby-wm/img/back.png"
                                                decoding="async"
                                                data-nimg="fill"
                                                style={{
                                                    filter: "hue-rotate(191deg) brightness(1)",
                                                    position: "absolute",
                                                    inset: 0,
                                                    boxSizing: "border-box",
                                                    padding: 0,
                                                    border: "none",
                                                    margin: "auto",
                                                    display: "block",
                                                    width: 0,
                                                    height: 0,
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%"
                                                }}
                                            />
                                        </span>
                                    </div>
                                </button>
                            </div>
                            <div className="flex-grow text-center font-[700] leading-[1.3] text-[15px] xs:text-[17px] md:text-[25px]">
                                <div
                                    className="flex items-center"
                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                >
                                    <div className=" flex-1 text-left bg-clip-text text-transparent bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C] text-[12px] ml-2 xs:ml-4 xs:text-[17px] md:text-[25px] truncate ">
                                        ค่ายเกม
                                    </div>
                                    <div className="flex items-start text-[10px] xs:text-xs">
                                        <div className="text-[#757575]">ยอดเงิน:</div>
                                        <div className="mx-1.5 xs:mx-2">{this.state.balance}</div>
                                        <div
                                            className="
            relative cursor-pointer w-2.5 h-2.5 xs:w-3 xs:h-3
            false
          "
                                        >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="/build/web/igame-index-lobby-wm/img/refresh.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col overflow-hidden">
                            <div className="flex select-none">
                                <div className="relative min-w-[56px] h-14 ml-4 mr-1 mt-1 mb-3 pointer-events-none z-10">
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            overflow: "hidden",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            position: "absolute",
                                            inset: 0
                                        }}
                                    >
                                        <img
                                            src={this.state.activeProvider.icon}
                                            decoding="async"
                                            data-nimg="fill"
                                            className="rounded-md pointer-events-none"
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                boxSizing: "border-box",
                                                padding: 0,
                                                border: "none",
                                                margin: "auto",
                                                display: "block",
                                                width: 0,
                                                height: 0,
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                                minHeight: "100%",
                                                maxHeight: "100%",
                                                objectFit: "cover"
                                            }}
                                        />
                                    </span>
                                    <div
                                        className="absolute left-0 right-0 top-0 bottom-0 rounded-md border border-[#B7A47C] pointer-events-none"
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    />
                                    <div
                                        className="absolute -bottom-[13px] left-1 right-1 h-[3px] bg-[#EE5F28] shadow-[0_0_6px_#D23801] rounded-[1px]"
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    />
                                    <div className="absolute top-0 bottom-0 -right-[20px] w-[18px] bg-gradient-to-r from-[#101010]" />
                                </div>
                                <div className="flex-1 pl-1 pb-4 pt-2 opacity-60 overflow-hidden">
                                    <Swiper
                                        className="mySwiper h-full"
                                        slidesPerView="auto"
                                        spaceBetween={6}
                                        freeMode
                                        grabCursor
                                    >
                                        {providorlist && providorlist.map((listitem, i) => (
                                            <SwiperSlide
                                                key={i}
                                                className=" max-w-[48px] mx-0.5 xs:mx-1"
                                            >
                                                <span
                                                    className={`relative w-full h-full block rounded-md overflow-hidden
    ${this.props.isLoadingGame ? "pointer-events-none opacity-40" : "cursor-pointer"}
  `}
                                                    onClick={() => {
                                                        if (this.props.isLoadingGame) return;

                                                        this.setState({
                                                            activeProvider: {
                                                                icon: listitem.imagesec,
                                                                partnerdesc: listitem.description,
                                                                partner: listitem.partner,
                                                            },
                                                        });

                                                        this.props.onNavigate(
                                                            `/listgameall/${segslist.seg2}/${listitem.partner}`
                                                        );
                                                    }}

                                                >
                                                    <img
                                                        src={listitem.imagesec}
                                                        className="absolute inset-0 w-full h-full object-cover rounded pointer-events-none"
                                                        alt=""
                                                    />

                                                    {/* border */}
                                                    <div
                                                        className="absolute inset-0 rounded-md border border-[#B7A47C] pointer-events-none"
                                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                    />
                                                </span>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>

                                </div>

                            </div>
                            <div className="scroller flex-1 overflow-y-auto no-scrollbar px-4 pt-3 pb-10">
                                <div
                                    className="border-t border-[#CCBC98]/10 -mx-4 -mt-3 mb-3"
                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                />
                                <div
                                    className="flex justify-between items-center whitespace-nowrap"
                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                >
                                    <div className="mb-1 text-[11px] font-semibold bg-clip-text text-transparent bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]">
                                        เข้าล็อบบี้ | {this.state.activeProvider.partnerdesc}
                                    </div>
                                    <div className="text-[10px] text-[#757575]">( {listitallgame.length} เกม )</div>
                                </div>
                                <div
                                    className="flex gap-1 mt-2 mb-4 overflow-auto px-4 -mx-4 no-scrollbar"
                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                >
                                    <div className="flex gap-2 items-center border rounded-md py-1 pr-2 pl-1 cursor-pointer select-none transition-all whitespace-nowrap bg-[#EE5F28] border-transparent">
                                        <div className="relative w-[23px] h-[18px]">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="https://cdn.zabbet.com/game_tags/all.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                                <noscript />
                                            </span>
                                        </div>
                                        <div className="flex-1 text-[12px]">ทั้งหมด</div>
                                    </div>
                                    <div className="flex gap-2 items-center border rounded-md py-1 pr-2 pl-1 cursor-pointer select-none transition-all whitespace-nowrap border-[#6f6e6e] opacity-50">
                                        <div className="relative w-[23px] h-[18px]">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="https://cdn.zabbet.com/game_tags/1677488686186-c7d0897e-0c08-4b65-9ede-32907cc9c2da.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="flex-1 text-[12px]">เกมส์อาเขต</div>
                                    </div>
                                    <div className="flex gap-2 items-center border rounded-md py-1 pr-2 pl-1 cursor-pointer select-none transition-all whitespace-nowrap border-[#6f6e6e] opacity-50">
                                        <div className="relative w-[23px] h-[18px]">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="https://cdn.zabbet.com/game_tags/1677488730506-449aaa85-0f00-4371-b6ad-5c970871eeb0.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                                <noscript />
                                            </span>
                                        </div>
                                        <div className="flex-1 text-[12px]">เกมส์สล็อต</div>
                                    </div>
                                    <div className="flex gap-2 items-center border rounded-md py-1 pr-2 pl-1 cursor-pointer select-none transition-all whitespace-nowrap border-[#6f6e6e] opacity-50">
                                        <div className="relative w-[23px] h-[18px]">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="https://cdn.zabbet.com/game_tags/1677488766370-ade8bad7-8b4d-4fc9-aba6-3dfe128c4593.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="flex-1 text-[12px]">เกมส์โต๊ะ</div>
                                    </div>
                                </div>
                                <div className="pt-1 pb-5 grid grid-cols-3 gap-x-[11px] gap-y-[8px]">

                                    {this.props.isLoadingGame
                                        ? Array.from({ length: 9 }).map((_, i) => (
                                            <GameSkeleton key={i} />
                                        ))
                                        : listitallgame && listitallgame.map((listitem, i) => (
                                            <div className="css-flyhp1" style={{ animationDelay: "0ms" }} key={i}>
                                                <div
                                                    className=""
                                                    onClick={() => this.setState({ activeCard: i })}
                                                >
                                                    <div className="relative p-[1px] xs:p-[2px]">

                                                        {/* กรอบทอง (เหมือนเดิม) */}
                                                        <div
                                                            className="absolute top-0 left-0 right-0 bottom-0
                     rounded-[15px] xs:rounded-[18px]
                     pointer-events-none
                     bg-gradient-to-b from-[#877345] via-[#c89f1a] to-[#877345]
                     rounded-tl-[2px] xs:rounded-tl-[2px]"
                                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                        />

                                                        {/* ตัวการ์ด */}
                                                        <div className="relative pb-[142%] bg-center bg-no-repeat bg-cover overflow-hidden rounded-[14px] xs:rounded-[17px] bg-black">

                                                            {/* รูป */}
                                                            <div className="absolute -top-[1px] -left-[1px] -right-[1px] -bottom-[1px]">
                                                                <img
                                                                    src={this.addDefaultSrc(null, listitem.image)}
                                                                    decoding="async"
                                                                    className="pointer-events-none absolute inset-0 w-full h-full object-cover"
                                                                />
                                                            </div>

                                                            {/* OVERLAY (เพิ่มเฉพาะตอน active) */}
                                                            {this.state.activeCard === i && (
                                                                <div
                                                                    className="absolute left-0 right-0 top-0 bottom-0
                         bg-black/80 backdrop-blur-sm
                         rounded-[14px] xs:rounded-[17px]
                         flex justify-center items-center"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <a
                                                                        className="flex flex-col xs:flex-row justify-center items-center
                           min-w-[75%] px-3 py-2 rounded-lg whitespace-nowrap
                           bg-gradient-to-b from-[#FDCF2A] via-[#FF9C1A] to-[#FF9C1A]
                           text-sm cursor-pointer"
                                                                        onClick={(e) => this.redeem(e, listitem.gameId, listitem.partner)}
                                                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                                    >
                                                                        <div className="relative flex justify-center items-center min-w-[20px] min-h-[20px]">
                                                                            <img
                                                                                src="/build/web/igame-index-lobby-wm/img/play_game.svg"
                                                                                className="absolute inset-0 w-full h-full object-contain"
                                                                            />
                                                                        </div>
                                                                        <span className="xs:ml-2">เข้าเล่น</span>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* badge (เหมือนเดิม) */}
                                                        {i < 5 && (
                                                            <div className="absolute left-[2px] -top-[2px] bottom-0 right-0 flex items-start pointer-events-none">
                                                                <div className="relative w-[28%] pb-[28%]">
                                                                    <img
                                                                        src="/build/web/igame-index-lobby-wm/img/hot.png"
                                                                        className="absolute inset-0 w-full h-full object-contain"
                                                                    />
                                                                </div>
                                                                <div className="relative w-[28%] pb-[28%]">
                                                                    <img
                                                                        src="/build/web/igame-index-lobby-wm/img/new.png"
                                                                        className="absolute inset-0 w-full h-full object-contain"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}


                                                    </div>

                                                    {/* ชื่อเกม (เหมือนอันล่าง) */}
                                                    <div className="xs:px-1.5 pt-1 text-[8px] xs:text-[10px] text-center">
                                                        {listitem.description}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}




                                </div>
                            </div>
                        </div>
                    </div>
                </main>


            </>

        );

    }
}
export default App;
